export const oldPromoClinicSlugMap = {
    'heart-2-heart': 'heart-2-heart',
    'womens-care': 'womens-care'
}